module.exports = __webpack_public_path__ + "908e4d2e/img/note-edit-icon.acae1669.svg";